/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@lc/legacy/src/Components';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import ViewDetail from 'components/Booking/ViewDetail';
import Availability from 'components/Booking/Availability';
import ListItems from './components/ListItems';

// import statusRules from 'src/helpers/statusRules'

const useStyles = makeStyles({
  marginSection: {
    marginTop: '10px',
  },
  marginContent: {
    marginTop: '12px',
  },
  hr: {
    border: '0',
    height: '1px',
    backgroundColor: '#a6a6a673',
  },
  gridList: {
    display: 'flex',
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
    overflow: 'auto',
    marginTop: '12px',
  },
  gridListImage: {
    width: '100px',
    margin: '10px',
  },
  priceLabel: {
    backgroundColor: '#f6f6f6',
    color: '#797979',
    padding: '8px 10px',
    borderRadius: '5px',
  },
  dashLi: {
    listStyle: 'none',
    marginLeft: '-16px',
    textTransform: 'capitalize',
  },
  btnCollapse: {
    maxHeight: '40px',
    padding: '0 !important',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const AdvertisingPlace = ({ data, CalendarBooking }) => {
  const classes = useStyles();
  const [viewDetail, setViewDetail] = useState();
  const xsSize = useMediaQuery(useTheme().breakpoints.down('xs'));
  const { t } = useTranslation(['booking', 'search']);

  const renderDescription = () => (
    <Typography className={classes.marginContent}>{data.description}</Typography>
  );
  const renderRules = () => <Typography className={classes.marginContent}>{data.rules}</Typography>;

  return (
    <>
      {viewDetail && <ViewDetail detail={viewDetail} close={() => setViewDetail(undefined)} />}
      <Grid container spacing={0}>
        <Grid item xs={12} className={classes.marginSection}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Typography
                color="secondary"
                style={{ marginBottom: '14px', fontWeight: '600', fontSize: '1.325em' }}
              >
                {data.name}
              </Typography>
              {data.expertise != 'Equipamento' ? <Typography
                variant={xsSize ? 'button' : 'body1'}
                component="p"
                style={{ fontWeight: '600' }}
              >
                {`${t('clinic')} ${data.expertise}`}
              </Typography> : null}

              {data?.specialties?.map((item, idx) => (
                <Typography key={item} variant={xsSize ? 'button' : 'body1'} component="span">
                  {item}
                  {idx < data.specialties.length - 1 && ', '}
                </Typography>
              ))}

              {data.expertise != 'Equipamento' ? <Typography
                variant={xsSize ? 'button' : 'body1'}
                component="p"
                color="textPrimary"
                style={{ marginTop: '10px' }}
              >
                {data?.address?.neighborhood}, {`${data?.address?.city}/${data?.address?.state}`}
              </Typography> : null}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.marginSection}>
          <hr className={classes.hr} />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Button
                size="small"
                fullWidth
                className={classes.btnCollapse}
                disabled={!xsSize}
                onClick={() => {
                  setViewDetail({ title: t('description'), content: renderDescription() });
                }}
              >
                <Typography variant={xsSize ? 'body2' : 'body1'} color="textPrimary">
                  <b>{t('description')}</b>
                </Typography>
                {xsSize && <ChevronRightIcon />}
              </Button>
              {!xsSize && renderDescription()}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <hr className={classes.hr} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Button
                size="small"
                fullWidth
                className={classes.btnCollapse}
                disabled={!xsSize}
                onClick={() => {
                  setViewDetail({ title: t('rulesWorkplace'), content: renderRules() });
                }}
              >
                <Typography variant={xsSize ? 'body2' : 'body1'} color="textPrimary">
                  <b>{t('rulesWorkplace')}</b>
                </Typography>

                {xsSize && <ChevronRightIcon />}
              </Button>
              {!xsSize && renderRules()}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <hr className={classes.hr} />
        </Grid>

        {data.expertise != 'Equipamento' ?
          <><Grid item xs={12} className={classes.marginSection}>
            <Grid container spacing={0}>
              <Grid item md={6}>
                <Typography variant={xsSize ? 'body2' : 'body1'} color="textPrimary">
                  <b>{t('conveniences')}</b>
                </Typography>
                {data.conveniences ? <ListItems data={data.conveniences} size={xsSize ? 3 : data.conveniences.length} /> : null}

                {xsSize && data.conveniences.length > 3 && (
                  <Button
                    size="xs"
                    onClick={() => {
                      setViewDetail({
                        title: t('conveniences'),
                        content: (
                          <ListItems data={data.conveniences} size={data.conveniences.length} />
                        ),
                      });
                    }}
                  >
                    <Typography variant="button" color="secondary">
                      <strong>{t('showMore')}</strong>
                    </Typography>
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
            <Grid item xs={12} className={classes.marginSection}>
              <hr className={classes.hr} />
            </Grid>
          </> : null}

        {data.equipConveniences?.length ?
          <>
            <Grid item xs={12} className={classes.marginSection}>
              <Grid container spacing={0}>
                <Grid item md={6}>
                  <Typography variant={xsSize ? 'body2' : 'body1'} color="textPrimary">
                    <b>{t('equipConveniences')}</b>
                  </Typography>
                  <ListItems
                    dash="-"
                    data={data.equipConveniences}
                    size={xsSize ? 3 : data.equipConveniences.length}
                  />

                  {xsSize && data.equipConveniences.length > 3 && (
                    <Button
                      size="xs"
                      onClick={() => {
                        setViewDetail({
                          title: t('equipConveniences'),
                          content: (
                            <ListItems
                              dash="-"
                              data={data.equipConveniences}
                              size={data.equipConveniences.length}
                            />
                          ),
                        });
                      }}
                    >
                      <Typography variant="button" color="secondary">
                        <strong>{t('showMore')}</strong>
                      </Typography>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.marginSection}>
              <hr className={classes.hr} />
            </Grid>
          </>
          : null}

        {data.securityConveniences?.length ?
          <>
            <Grid item xs={12} className={classes.marginSection}>
              <Grid container spacing={0}>
                <Grid item md={6}>
                  <Typography variant={xsSize ? 'body2' : 'body1'} color="textPrimary">
                    <b>{t('securityConveniences')}</b>
                  </Typography>

                  <ListItems
                    dash="-"
                    data={data.securityConveniences}
                    size={xsSize ? 3 : data.securityConveniences.length}
                  />

                  {xsSize && data.securityConveniences.length > 3 && (
                    <Button
                      size="xs"
                      onClick={() => {
                        setViewDetail({
                          title: t('securityConveniences'),
                          content: (
                            <ListItems
                              dash="-"
                              data={data.securityConveniences}
                              size={data.securityConveniences.length}
                            />
                          ),
                        });
                      }}
                    >
                      <Typography variant="button" color="secondary">
                        <strong>{t('showMore')}</strong>
                      </Typography>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.marginSection}>
              <hr className={classes.hr} />
            </Grid>
          </>
          : null}

        <Grid item xs={12} className={classes.marginSection}>
          <Availability title={t('availability')} data={data} setViewDetail={setViewDetail} />
        </Grid>
        <Grid item xs={12} className={classes.marginSection}>
          {CalendarBooking}
        </Grid>

        <Grid item xs={12} className={classes.marginSection}>
          {data.expertise != 'Equipamento' ?
            <hr className={classes.hr} />
            : null}
        </Grid>

        {data.expertise != 'Equipamento' ?
          <Grid item xs={12} className={classes.marginSection}>
            <Grid container spacing={0}>
              <Grid item md={6}>
                <Typography variant={xsSize ? 'body2' : 'body1'} color="textPrimary">
                  <b>{t('localization')}</b>
                </Typography>
                <Typography variant="button">
                  {t('workplaceIsLocateIn', {
                    name: data.firstName,
                    neighborhood: data?.address?.neighborhood,
                    city: data?.address?.city,
                    state: data?.address?.state,
                  })}
                </Typography>
              </Grid>
            </Grid>
          </Grid> : null}
      </Grid>
    </>
  );
};

AdvertisingPlace.propTypes = {
  CalendarBooking: PropTypes.node.isRequired,
  data: PropTypes.object,
};

AdvertisingPlace.defaultProps = {
  data: undefined,
};

export default AdvertisingPlace;
